/**
 * CreateWorkspaceModal - modal shell around CreateWorkspaceStep.
 *
 * Triggered from the workspace switcher footer ("+ New workspace") and from
 * any other surface that needs to add a workspace inline (e.g. workspace
 * settings → "+ Add another"). Keeps the modal shell concerns (sizing,
 * dismiss) separate from the form.
 *
 * @module components/workspace/CreateWorkspaceModal
 */

import React from 'react';
import { Modal } from '../ui/Modal';
import { CreateWorkspaceStep } from './CreateWorkspaceStep';

interface CreateWorkspaceModalProps {
  /** Whether the modal is open. */
  open: boolean;
  /** Close handler - backdrop click, Escape, or successful create. */
  onClose: () => void;
}

/**
 * Lightweight modal wrapper around `CreateWorkspaceStep`. Closes on
 * successful create - the new workspace is already active via
 * `useOrg().createWorkspace`.
 */
export const CreateWorkspaceModal: React.FC<CreateWorkspaceModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose} title="Name your workspace" maxWidth="max-w-md">
      <CreateWorkspaceStep submitLabel="Create" onComplete={onClose} hideHeading />
    </Modal>
  );
};

export default CreateWorkspaceModal;
